module.exports = __webpack_public_path__ + "img/credento@2x.3d98a24.png";